import React, { Component } from 'react';
import styled from 'styled-components';
import { PrestoAppTheme, PrestoAppComponents } from 'presto-mini-apps-lib';
import { defaultOverlayStyle } from '../../constants/appState';
import {
    term_ok
} from '../../constants/text';

class LoyaltyMessageModal extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const {
            title,
            message,
            isOpen,
            onClose,
        } = this.props;
        return (
            <React.Fragment>
                <ModalOverlayWrapper className={[
                    'modal-overlay',
                    (!!isOpen ? ' show' : '')
                ].join('')}>
                    <div className="overlay" />
                    <ModalPanelWrapper className="popup-panel">
                        <div className="panel-header">
                            <div className="title">{title}</div>
                        </div>
                        <div className="panel-body" dangerouslySetInnerHTML={{__html: message}} />
                        <div className="panel-action">
                            <ModalButton
                                className="positive-button"
                                onClick={ onClose }
                            >{term_ok}</ModalButton>
                        </div>
                    </ModalPanelWrapper>

                </ModalOverlayWrapper>
            </React.Fragment>
        );
    }

}

export default LoyaltyMessageModal;

const ModalOverlayWrapper = styled.div`
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    z-index: 100;
    
    & .overlay {
        ${defaultOverlayStyle}
    }
    
    &.show {
        display: flex;
    }
`;

const commonBorderRadius = 6; // 6px
const commonBoxShadow = '0 1px 4px rgba(0, 0, 0, 0.1)';

const ModalPanelWrapper = styled.div`
    position: relative;
    width: calc(100% - 5 * ${PrestoAppTheme.layout.largeGap});
    border-radius: ${commonBorderRadius}px;
    box-shadow: ${commonBoxShadow};
    background-color: ${PrestoAppTheme.colors.white};
    border: solid ${PrestoAppTheme.colors.white} 1pt;
    display: flex;
    flex-direction: column;
    padding: 1rem;

    & .panel-header {
        padding: 0.5rem 0;
        text-align: center;
        box-sizing: border-box;
        flex: 1;
        
        & .title {
            font-weight: 500;
        }
    }

    & .panel-body {
        padding: 0.5rem 0 1rem;
        text-align: center;
        box-sizing: border-box;
        flex: 3;
        font-weight: 200;
    }

    & .panel-action {
        display: flex;
        text-align: center;
        box-sizing: border-box;
        justify-content: center;
        flex: 1;
        opacity: 100%;
        border-top: 1px solid ${PrestoAppTheme.colors.baseGrey};

        & .negative-button {
            margin-left: ${PrestoAppTheme.layout.commonGap};

        }

        & .positive-button {
            margin-left: ${PrestoAppTheme.layout.commonGap};
            color: ${PrestoAppTheme.colors.prestoRed};
        }
    }
`;

const ModalButton = styled.button`
    display: inline-block;
    height: ${PrestoAppTheme.layout.buttonHeightStandard};
    padding: 0 ${PrestoAppTheme.layout.smallGap};
    border: 0;
    border-radius: ${commonBorderRadius}px;
    line-height: ${PrestoAppTheme.layout.buttonHeightStandard};
    background-color: ${PrestoAppTheme.colors.white};

    font-size: ${PrestoAppTheme.layout.fontSizeSmall};
    text-align: center;
    box-sizing: border-box;
    outline: 0;
    white-space: nowrap;
    cursor: pointer;

    &.large {
        height: ${PrestoAppTheme.layout.buttonHeightLarge};
    }

    &:disabled,
    &.disabled {
        background-color: ${PrestoAppTheme.colors.white};
        cursor: default;
    }
`;